<div class="page-header">
  <div class="header-top">
    <h1>{{ isKumMode ? 'KÜM' : 'CC' }} Összesítő</h1>
    <!-- ✅ Switch nem CC munkatársak számára, ill. kettős (CC+KÜM) szerepkör esetén látható -->
    @if (!isCallCenterEmployee || isBothCcAndKum) {
      <div class="mode-switch">
        <label class="switch-label">
          <span class="switch-text">{{ isKumMode ? 'KÜM' : 'CC' }} oldal</span>
          <label class="switch">
            <input
              type="checkbox"
              [(ngModel)]="isKumMode"
              [ngModelOptions]="{standalone: true}"
              [disabled]="isKumEmployee"
              (change)="onModeChange()">
            <span class="slider" [class.disabled]="isKumEmployee"></span>
          </label>
        </label>
      </div>
    }

    @if (showExport) {
      <button mat-icon-button
              type="button"
              class="export-button"
              [disabled]="exportDisabled || isExporting"
              matTooltip="Exportálás XLSX-be"
              aria-label="Exportálás XLSX-be"
              (click)="onExportClick()">
        <mat-icon>download</mat-icon>
      </button>
    }
  </div>
  <div class="controls">
    <div class="date-controls">
      <div class="control-group">
        <label for="month-select">Hónap:</label>
        <select
          id="month-select"
          [(ngModel)]="selectedMonth"
          [ngModelOptions]="{standalone: true}"
          (change)="onMonthChange()"
          class="form-select">
          @for (month of visibleMonths; track month) {
            <option [value]="month">
              {{ month | titlecase }}
            </option>
          }
        </select>
      </div>

      <div class="control-group">
        <label for="year-input">Év:</label>
        <input
          id="year-input"
          type="number"
          [(ngModel)]="selectedYear"
          [ngModelOptions]="{standalone: true}"
          (change)="onYearChange()"
          class="form-input"
          min="2020"
          max="2030">
      </div>

      @if (!isYearlyView) {
        <div class="info-group">
          <span class="days-info">Napok száma: {{ daysInMonth }}</span>
        </div>
      }
      @if (isYearlyView) {
        <div class="info-group">
          <span class="days-info">Éves összesítő nézet</span>
        </div>
      }
    </div>
  </div>
</div>